import api from "../api/axios";


export const obtenerHorarios = async () => {
    const response = await api.get("/horarios");
    return response.data;
};

export const obtenerHorariosCategoria = async () => {
    const response = await api.get("/indexCategoriaHorario");
    return response.data;
};



export const obtenerHorario = async (id) => {
    const response = await api.get(`/horarios/${id}`);
    return response.data;
};

export const crearHorario = async (formData) => {
    const response = await api.post(
        "/admin/horarios",
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );

    return response.data;
};

export const actualizarHorario = async (id, formData) => {
    formData.append("_method", "PUT");

    const response = await api.post(
        `/admin/horarios/${id}`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );

    return response.data;
};

export const eliminarHorario = async (id) => {
    const response = await api.delete(
        `/admin/horarios/${id}`
    );

    return response.data;
};